import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';
import colors from '../../styles/colors';
import { Container, Row, Col } from 'react-bootstrap';

const BaseFooter = ({ className, content, data }) => (
  <div className={className}>
    <Container>
      <Row>
        <Col xs={{ order: 2, span: 6 }} md={{ order: 1, span: 3 }}>
          <div className="gallery-button">
            <Link to="/projects/">VIEW GALLERY &raquo;</Link>
          </div>
        </Col>
        <Col xs={{order: 1, span: 12 }} md={{ order: 2, span: 6 }}>
          <div className="footer-meta">
            <div>
              <a href={`tel:${content.contact.phone}`}>{content.contact.phone}</a>
              <br/>
              <a href={`mailto:${content.contact.email}`}>{content.contact.email}</a>
            </div>
            <div>
              {content.address.map((addressLine, index) => (
                <p key={index}>{addressLine}</p>
              ))}
            </div>
          </div>
        </Col>
        <Col xs={{ order: 3, span:6  }} md={{ order:3, span:3}}>
          <div className="imageWrapper" style={{ margin: "auto" }}> {/* putting the margin: auto here was the only thing that worked*/}
            <Img fluid={data.file.childImageSharp.fluid}/>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

const Footer = styled(BaseFooter)`
  display: flex;
  justify-content: space-between;
  background-color: ${colors.darkGray};
  padding: 20px 15px;
  color: white;

  div {
    align-self: center;
  }

  .imageWrapper {
    width: 160px;
    
    @media screen and (min-width: 768px){
      max-width: 160px;
      min-width: 30px;
    }
  }

  .footer-meta div {
    text-align: center;
    margin-bottom: 8px;
  }
  p {
    margin: 0;
  }
  a {
    color: white;
    text-decoration: none;
    vertical-align: middle;
  }
`;

export default props => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "made-with-pride-with-text.png" }) {
          childImageSharp {
            fluid(maxWidth: 160) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Footer data={data} {...props} />}
  />
);
